// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"21526868","457":"818b026d","522":"ac069fd5","892":"40b3e017","944":"dea79d96"}[chunkId] + ".chunk.js";
};